<template>
  <div class="chart-box">
    <DefaultBarChart :data="data" :loading="loading" :options="chartOptions" />
  </div>
</template>
<script>
import DefaultBarChart from '@/components/DefaultBarChart.vue';

const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Maj',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dec'
];

export default {
  components: {
    DefaultBarChart
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    avgProcessingDays: {
      type: Object,
      default: () => ({})
    },
    selectedYear: {
      type: String,
      default: 'all'
    }
  },
  computed: {
    monthlyValues() {
      const result = [];
      for (let i = 1; i <= 12; i++) {
        const mm = String(i).padStart(2, '0');
        const byYear = {};
        let sum = 0;
        let count = 0;

        for (const [year, yearData] of Object.entries(
          this.avgProcessingDays || {}
        )) {
          if (this.selectedYear !== 'all' && year !== this.selectedYear) {
            continue;
          }
          const key = `${year}-${mm}`;
          const val = yearData?.[key];
          if (val === undefined || val === null) continue;
          const num = Number(val) || 0;
          byYear[year] = num;
          sum += num;
          count += 1;
        }

        const avg = count ? sum / count : 0;
        result.push({
          month: mm,
          label: MONTH_LABELS[i - 1],
          value: Math.round(avg),
          byYear
        });
      }
      return result;
    },
    data() {
      return {
        labels: this.monthlyValues.map(m => m.label),
        datasets: [
          {
            label: 'Dagar',
            backgroundColor: '#409fff',
            borderRadius: 4,
            data: this.monthlyValues.map(m => m.value)
          }
        ]
      };
    },
    chartOptions() {
      const months = this.monthlyValues;
      const isAll = this.selectedYear === 'all';
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            grace: '15%',
            title: {
              display: true,
              text: 'Dagar'
            }
          }
        },
        plugins: {
          legend: { display: false },
          datalabels: { display: false },
          tooltip: {
            callbacks: {
              label: ctx => {
                const m = months[ctx.dataIndex];
                if (!m) return '';
                if (!isAll) return `${m.value} dagar`;
                const years = Object.keys(m.byYear).sort();
                if (!years.length) return 'Ingen data';
                const parts = years.map(y => `${y}: ${m.byYear[y]} d`);
                return [`Snitt: ${m.value} dagar`, ...parts];
              }
            }
          }
        }
      };
    }
  }
};
</script>
<style scoped>
.chart-box {
  position: relative;
  height: 420px;
  width: 100%;
}
</style>
